<template>
  <div class="reset-pass">
    <div class="navbar_style" :class="$store.state.user.isNested && 'navbar_style_nested'">
      <Icon class="navbar_icon" name="arrow-left" @click="$router.back(1)" />
      <span>{{ l.login_reset_nav_title }}</span>
      <div class="icon_box"></div>
    </div>
    <div class="form-box">
      <Form
        ref="form"
        @submit="handleCommit"
        @failed="onFailed"
        :show-error-message="true"
      >
        <div class="label-box">
          <div class="label-title">{{ l.login_l_phone }}</div>
          <Field
            class="field-input"
            v-model="phone"
            name="phone"
            :placeholder="l.login_p_phone"
            maxlength="10"
            :rules="[
              { required: true, message: '' }, // l.login_p_phone
              {
                validator: checkPhone,
                message: `${
                  ![null, undefined].includes(phone)
                    ? l.login_p_phone_toast
                    : ''
                }`,
              }, // l.login_p_phone_toast
            ]"
          />
        </div>
        <div id="captcha"></div>
        <div class="label-box">
          <div class="label-title">{{ l.login_l_code }}</div>
          <Field
            class="field-input field-code"
            v-model="code"
            center
            name="code"
            :placeholder="l.login_p_code"
            maxlength="6"
            :rules="[
              { required: true, message: '' }, // l.login_p_code
              {
                pattern: /^\d{6}$/,
                message: `${
                  ![null, undefined].includes(phone) ? l.login_code_format : ''
                }`,
              }, // l.login_p_success_code
            ]"
          >
            <template #button>
              <Button
                class="btn"
                size="small"
                type="info"
                native-type="button"
                @click="handlecodebtn"
                :disabled="time === 0 ? false : true"
                >{{ time === 0 ? l.login_get_code : `${time}S` }}</Button
              >
            </template>
          </Field>
        </div>
        <div class="label-box">
          <div class="label-title">{{ l.login_l_password }}</div>
          <Field
            class="field-input"
            v-model="password"
            center
            clearable
            name="password"
            type="password"
            :placeholder="l.login_p_password"
            maxlength="20"
            :rules="[
              { required: true, message: '' }, // l.login_p_code
              {
                validator: checkPass,
                message: `${
                  ![null, undefined].includes(password)
                    ? l.login_pass_no_format
                    : ''
                }`,
              }, // l.login_p_success_code
            ]"
          />
        </div>
        <div class="label-box">
          <div class="label-title">{{ l.login_l_re_password }}</div>
          <Field
            class="field-input"
            v-model="rePassword"
            center
            clearable
            name="rePassword"
            type="password"
            :placeholder="l.login_p_re_password"
            maxlength="20"
            :rules="[
              { required: true, message: '' }, // l.login_p_code
              {
                validator: checkRePassword,
                message: `${
                  ![null, undefined].includes(rePassword)
                    ? l.login_pass_no_same
                    : ''
                }`,
              }, // l.login_p_success_code
            ]"
          />
        </div>
        <div class="tips">{{ l.login_pass_tips }}</div>
        <div style="padding:0 22px;">
          <Button
            class="resetSubmit"
            :class="isOver && 'loginOver'"
            size="normal"
            type="info"
            block
            native-type="submit"
            >{{ l.login_ok }}</Button
          >
        </div>
      </Form>
    </div>
    <van-dialog
      class="dialog-go-res-page"
      v-model="show"
      :title="l.login_title_tips"
      show-cancel-button
      :cancel-button-text="l.login_btn_cancel"
      :confirm-button-text="l.login_ok"
      @confirm="goResPage"
    >
      <div class="dialog-go-res-page-content">
        {{ l.login_content_go_res }}
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Icon, Form, Field, Button, Toast, Dialog } from "vant";

import { checkPhone, checkPass, passEncryption } from "@/utils/index";
// import { CAPTCHA_ID } from "@/utils/config";

import { code, reSetPassword } from "@/services/user";

import l from "@/locales";

export default {
  name: "resetPass",
  components: {
    Icon,
    Form,
    Field,
    Button,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      phone: null,
      code: null,
      password: null,
      rePassword: null,
      l: l.login,
      captchaIns: {},
      time: 0, // 获取验证码倒计时
      show: false,
      isOver: false,
    };
  },
  watch: {
    phone: "checkForm",
    code: "checkForm",
    password: "checkForm",
    rePassword: "checkForm",
  },
  methods: {
    checkPhone,
    checkPass,
    checkForm() {
      if (
        this.checkPhone(this.phone) &&
        this.checkCode(this.code) &&
        this.checkPass(this.password) &&
        this.checkRePassword(this.rePassword)
      ) {
        this.isOver = true;
      } else {
        this.isOver = false;
      }
    },
    checkCode(str) {
      return /^\d{6}$/.test(str);
    },
    checkRePassword(value) {
      if (value === "") {
        return false;
      } else if (value !== this.password) {
        return false;
      }
      return true;
    },
    goResPage() {
      // 去注册页 预设登陆类型
      sessionStorage.setItem("loginType", 2);
      this.$router.back(1);
    },
    handleCommit(e) {
      if (!this.isOver) {
        return;
      }
      const { phone, code, password, rePassword } = e;
      // 提交点赞业务请求
      const params = {
        phone,
        vcode: code,
        password: passEncryption(password),
        rePassword: passEncryption(rePassword),
        showError: false,
      };
      reSetPassword(params)
        .then((res) => {
          if (res.code == 200) {
            // 重置成功
            Toast.success({
              message: this.l.login_pass_reset_success,
              forbidClick: true,
              onClose: () => {
                // this.$router.replace("/login");
                this.$router.back(1);
              },
            });
          }
        })
        .catch((err) => {
          console.log("catch", err);
          if (err?.code != 30039) {
            // 不是注册
            // toast
            err.msg && Toast.fail(err.msg);
            return;
          }
          // 弹窗
          this.show = true;
        });
    },
    onFailed(err) {
      console.log(err);
    },
    /**
     * @desc 易盾校验
     */
    handlecodebtn() {
      if (!this.phone || this.phone === "") {
        Toast.fail(this.l.login_p_phone);
        return;
      }
      if (!checkPhone(this.phone)) {
        Toast.fail(this.l.login_p_phone_toast);
        return;
      }
      this.sendCode();
    },
    sendCode() {
      const params = { phone: this.phone, type: 3 };
      code(params).then((res) => {
        if (res.code == 200) {
          this.time = 60;
          this.timer = setInterval(() => {
            if (this.time <= 1) {
              clearInterval(this.timer);
            }
            this.time--;
          }, 1000);
        }
      });
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.reset-pass {
  height: 100%;
  min-height: 100vh;
  background-color: #ffffff;
}
.form-box {
  padding: 20px;
  box-sizing: border-box;

  .label-box {
    background: #fff;
    .label-title {
      margin-bottom: 10px;

      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3f414c;
    }
    .field-input {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      padding: 0 20px;
      padding-right: 10px;
      box-sizing: border-box;

      height: 44px;
      background: rgba(69,161,255,0.1);
      border-radius: 21px;
      border: 1px solid #EF9614;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9d9fa8;

      /deep/ .van-field__control {
        color: #3f414c;
      }

      /deep/ .van-field__error-message {
        position: absolute;
        top: 50%;
        right: 50px;
        transform: translateY(-50%);
      }
    }
    .field-code {
      /deep/ .van-field__error-message {
        position: absolute;
        top: 50%;
        right: 120px;
        transform: translateY(-50%);
      }
    }

    &:last-child {
      .field-input {
        margin-bottom: 0;
      }
    }
  }
  .tips {
    transform: translateY(-10px);
    font-size: 11px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff5225;
  }
  .resetSubmit {
    border: none;
    margin: 0 auto;
    margin-top: 30px;

    height: 44px;
    background: #6d707b;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.16);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
  .loginOver {
    color: #ffffff;
    background: #F8FBFF;
  }
}
.btn {
  background-color: transparent;
  border: none;
  box-sizing: border-box;

  flex: 1;
  height: 100%;

  height: 28px;
  background: #F8FBFF;
  border-radius: 14px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
/deep/ .van-overlay {
  background: rgba(101, 101, 101, 0.2);
  backdrop-filter: blur(3px);
}
.dialog-go-res-page {
  width: 293px;
  height: 198px;
  background: #ffffff;
  border-radius: 10px;

  .dialog-go-res-page-content {
    text-align: center;
    margin: 24px auto 0;
    width: 239px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232425;
  }
  /deep/ .van-dialog__header {
    padding-top: 18px;
    padding-bottom: 10px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232425;

    border-bottom: 1px solid #d8d8d8;
  }
  /deep/ .van-dialog__footer {
    position: absolute;
    bottom: 21px;
  }
  /deep/ .van-dialog__cancel {
    margin-left: 22px;
    margin-right: 18px;
    width: 114px;
    height: 38px;
    background: #d8d8d8;
    border-radius: 19px;

    .van-button__text {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6d7278;
    }
  }
  /deep/ .van-dialog__confirm {
    margin-right: 22px;
    width: 114px;
    height: 38px;
    background: #d8d8d8
      linear-gradient(90deg, #ebcfa4 0%, #dcb98f 47%, #cfa77d 100%);
    border-radius: 19px;

    .van-button__text {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
</style>
